export const FLAG_ENABLE_CH_DASHBOARD_ANALYTICS =
  'content-hub-enable-dashboard-analytics';

export const FLAG_ENABLE_CONTENT_LIBRARY_ORG_DASHBOARD =
  'content-library-org-dashboard';

export const FLAG_ENABLE_VIDEO_ANALYTICS_EXPORT =
  'content-hub-enable-video-analytics-export';

export const FLAG_ENABLE_ANALYTICS_LEAD_FILTER =
  'content-hub-analytics-enabled-lead-filter';

export const FLAG_ENABLE_CSV_REPORTS_IMPROVEMENTS = 'csv-reports-improvements';

export const FLAG_ENABLE_CONTENT_HUB_DASHBOARD_QUICK_LINKS =
  'content-hub-enable-dashboard-quick-links';
